module.exports = __webpack_public_path__ + "static/media/shopify_logo.a3cf3662.png";